import {
  Col, DatePicker, Form,
  Modal, Progress, Row,
  Select, Tooltip,
} from 'antd';
import React, { ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { GUTTOR_SPACE, GUTTOR_SPACE_SMALL, UPC_DATE_FORMAT } from '../../constants/commonConstants';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/i_info_fill.svg';
import { ReactComponent as StarWithCircleIcon } from '../../../assets/images/svg/star-line-circle.svg';
import { getUserPerformance, getUserPerformanceSuccess } from '../../../store/actions/authAction';
import { RootState } from '../../../store';
import NumberFormatView from '../NumberFormatView/NumberFormatView';
import ApplicationDetail from '../../services/applicationDetail.service';
import IhxLogo from '../../../layout/leftsidebar/logo/IhxLogo';
import { DISABLE_PERFORMANCE_CARD_DATE_BEFORE, PERFORMANCE_CARD_MONTHS_OPTIONS } from '../../constants/crmConstants';
import './performance-card.less';

const PerformanceCard = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const appService = ApplicationDetail.instance;
  const hospitalDetails = appService.getHospitalDetail();
  const { Option } = Select;
  const [performanceCardForm] = Form.useForm();

  const [open, setOpen] = useState<any>(false);

  const userPerformance = useSelector((state: RootState): any => state?.auth?.userPerformance);
  const {
    userRank = 0,
    activeDays = 0,
    averageClaimPerDay = 0,
    claimsApprovedInFirstInstance = 0,
    claimshandled = 0,
    daysInDayShift = 0,
    daysInNightShift = 0,
    deniedRate = 0,
    discharge = 0,
    endtoendclaims = 0,
    newAdmission = 0,
    queriesresponded = 0,
    valueofclaimshandledbyapprovedamount = 0,
    maximumClaimInDay = 0,
    mins_InitiateDischarge = 0,
    median_InitiateDischarge = 0,
    max_InitiateDischarge = 0,
    mins_RespondToQuery = 0,
    median_RespondToQuery = 0,
    max_RespondToQuery = 0,
    automationClaim = 0,
  } = userPerformance || {};

  const btnClickHandler = (): void => {
    monthChangeHandler('SET_DEFAULT_DATE');
    if (!open) {
      dispatch(getUserPerformance({}));
      setOpen(true);
    } else {
      dispatch(getUserPerformanceSuccess({}));
      setOpen(false);
    }
  };

  const fetchUserPerformanceData = (): void => {
    const data =
      performanceCardForm
      .getFieldsValue([
        'startDate',
        'endDate',
      ]);
    dispatch(getUserPerformance(data));
  };

  const dateChangeHandler = (e: any, name: string): void => {
    if (name === 'startDate') {
      performanceCardForm.setFields([{
          name: 'startDate',
          value: e,
          errors: [],
      }]);
    } else {
      performanceCardForm.setFields([{
          name: 'endDate',
          value: e,
          errors: [],
      }]);
    }

    performanceCardForm.setFields([{
      name: 'quickFilter',
      value: null,
      errors: [],
    }]);

    fetchUserPerformanceData();
  };

  const monthChangeHandler = (quickFilterValue: any): void => {
    let updatedStartDate = moment().startOf('month');
    let updatedEndDate = moment();

    if (quickFilterValue === 'PREVIOUS_MONTH') {
      const prevMontStartDate = moment().subtract(1, 'months').date(1);

      updatedStartDate =
        prevMontStartDate > moment(DISABLE_PERFORMANCE_CARD_DATE_BEFORE).startOf('day')
          ? moment().subtract(1, 'months').date(1)
          : moment(DISABLE_PERFORMANCE_CARD_DATE_BEFORE);
      updatedEndDate = moment().subtract(1, 'months').endOf('month');
    } else if (quickFilterValue === 'SET_DEFAULT_DATE') {
      updatedStartDate = moment().subtract(1, 'months');
    }

    performanceCardForm.setFields([
      {
        name: 'startDate',
        value: updatedStartDate,
        errors: [],
      },
      {
        name: 'endDate',
        value: updatedEndDate,
        errors: [],
      },
    ]);
    fetchUserPerformanceData();
  };

  const disabledDate = (current: any, dateType: string): any => {
    if (dateType === 'startDate') {
      return current && current < moment(DISABLE_PERFORMANCE_CARD_DATE_BEFORE).startOf('day');
    }  else {
      const { startDate } = performanceCardForm.getFieldsValue(['startDate']);
      return current && current < moment(startDate).endOf('day');
    }
  };

  // const downloadPerformanceCad = (): any => {
  // };

  return (
    <>
      <Tooltip title="Performance Card" placement="bottom">
        <div>
          <StarWithCircleIcon onClick={btnClickHandler} />
        </div>
      </Tooltip>

      <Modal
        centered={true}
        visible={open}
        width={998}
        closable={false}
        className="performance-modal"
        footer={null}
        onCancel={btnClickHandler}
      >
        <div id="performance-card">
        <Row
            gutter={GUTTOR_SPACE}
            className="performance-modal__header"
          >
            <Col md={6}>
              <IhxLogo />
            </Col>
            <Col
              md={12}
              className="performance-modal__title"
            >
              Performance Card
            </Col>
            <Col
              md={6}
              className="text-right"
            >
              <img
                src={`${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/User.svg`}
                className="mr-5"
              />
              <span>{hospitalDetails?.providerName}</span>
            </Col>
          </Row>
          <Form
            layout="vertical"
            autoComplete="off"
            form={performanceCardForm}
          >
            <Row gutter={GUTTOR_SPACE}>
              <Col md={5}>
                <Form.Item
                  name="startDate"
                  label="Start Date"
                >
                  <DatePicker
                    format={UPC_DATE_FORMAT}
                    placeholder="dd/mm/yyyy"
                    onChange={(e: any): void => dateChangeHandler(e, 'startDate')}
                    disabledDate={(e: any): any => disabledDate(e, 'startDate')}
                  />
                </Form.Item>
              </Col>
              <Col md={5}>
                <Form.Item
                  name="endDate"
                  label="End Date"
                >
                  <DatePicker
                    format={UPC_DATE_FORMAT}
                    placeholder="dd/mm/yyyy"
                    onChange={(e: any): void => dateChangeHandler(e, 'endDate')}
                    disabledDate={(e: any): any => disabledDate(e, 'endDate')}
                  />
                </Form.Item>
              </Col>
              <Col md={5}>
                <Form.Item
                  name="quickFilter"
                  label="Quick Filter"
                >
                  <Select
                    className="w-100"
                    data-testid="inpatient-filter"
                    showSearch={true}
                    placeholder="Select"
                    optionFilterProp="children"
                    onChange={monthChangeHandler}
                  >
                    {
                      PERFORMANCE_CARD_MONTHS_OPTIONS.map(
                        (op: any, index: number): any =>
                          <Option
                            value={op?.value}
                            key={index}
                            data-testid={'quickFilter-' + op?.value}
                          >
                            {op?.label}
                          </Option>,
                      )
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Row gutter={GUTTOR_SPACE}>
            <Col md={7}>
              <Row className="performance-modal__data-wrapper">
                <Col md={24} className="performance-modal__data-header">
                  <Row>
                    <Col md={5} className="pl-0">
                    <img
                      src={
                        `${process.env.REACT_APP_COMMON_BUCKET_URL}${
                            userRank === 1 ? 'svg-assets/gold-medal.svg' : (
                              userRank === 2 ? 'svg-assets/silver-medal.svg'
                              : 'svg-assets/bronze-medal.svg'
                            )
                          }`
                        }
                    />
                    </Col>
                    <Col md={18} className="claim-center">
                      <div>
                        <p className="value white">{claimshandled}</p><p>Claims handled</p>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={24} className="sidebar-content"><p className="value">{averageClaimPerDay}</p><p>Average claims per day</p></Col>
                <Col md={24} className="sidebar-content">
                  <p className="value">{maximumClaimInDay}</p>
                  <p>Maximum claims handled in a day</p>
                </Col>
                <Col md={24} className="sidebar-content">
                  <p className="value">
                  <NumberFormatView
                    amount={Math.round(valueofclaimshandledbyapprovedamount)}
                    prefix={'₹ '}
                  />
                  </p>
                  <p>Value of approved claims</p>
                </Col>
                <Col md={24} className="sidebar-content">
                  <p className="value">{automationClaim}</p>
                  <p>
                    No. of automated claims
                    <Tooltip title="Only for Medi Assist cases">
                      <InfoIcon/>
                    </Tooltip>
                  </p>
                </Col>
              </Row>
            </Col>
            <Col md={17}>
              <Row className="performance-modal__data-wrapper">
                <Col md={6}>
                  <p className="value">
                    <NumberFormatView amount={newAdmission} />
                  </p>
                  <p>Admissions/<br/>Enhancements</p>
                </Col>
                <Col md={6}>
                  <p className="value">
                    <NumberFormatView amount={discharge} />
                  </p>
                  <p>Discharges</p>
                </Col>
                <Col md={6}>
                  <p className="value">
                    <NumberFormatView amount={endtoendclaims} />
                  </p>
                  <p>
                    End to end claims
                    <Tooltip title="No. of claims submitted through IHX at each stage.">
                      <InfoIcon/>
                    </Tooltip>
                  </p>
                </Col>
                <Col md={6}>
                  <p className="value">
                    <NumberFormatView amount={queriesresponded} />
                  </p>
                  <p>Queries responded</p>
                </Col>
              </Row>
              <Row className="performance-modal__data-wrapper">
                <Col md={12}>
                  <p className="value">{deniedRate}%</p>
                  <p>Denial rate</p>
                  <Progress
                    percent={deniedRate}
                    size="small"
                    status="exception"
                    trailColor="#2AE1AA"
                    showInfo={false}
                  />
                </Col>
                <Col md={12}>
                  <p className="value">{claimsApprovedInFirstInstance} %</p>
                  <p>Claims approved in first instance</p>
                  <Progress
                    percent={claimsApprovedInFirstInstance}
                    size="small"
                    strokeColor="#2AE1AA"
                    trailColor="rgb(151, 151, 151, 0.4)"
                    showInfo={false}
                  />
                </Col>
              </Row>
              <Row className="performance-modal__data-wrapper">
                <Col md={8} className="pb-0">
                  <p className="value">{mins_InitiateDischarge} min</p>
                  <p>Best time taken to<br/>initiate discharge</p>
                  </Col>
                <Col md={8} className="pb-0">
                  <p className="value">{median_InitiateDischarge} min</p>
                  <p>Median time taken<br/>to initiate discharge</p>
                </Col>
                <Col md={8} className="pb-0">
                  <p className="value">{max_InitiateDischarge} min</p>
                  <p>Max time taken<br/>to initiate discharge</p>
                  </Col>
                <Col md={8}>
                  <p className="value">{mins_RespondToQuery} min</p>
                  <p>Best time taken to<br/>respond to a query</p>
                </Col>
                <Col md={8}>
                  <p className="value">{median_RespondToQuery} min</p>
                  <p>Median time taken to<br/>respond to a query</p>
                </Col>
                <Col md={8}>
                  <p className="value">{max_RespondToQuery} min</p>
                  <p>Max time taken to<br/>respond to a query</p>
                </Col>
              </Row>
              <Row gutter={GUTTOR_SPACE_SMALL}>
                <Col md={8}>
                  <Row className="performance-modal__data-wrapper">
                    <Col md={24}>
                      <p className="value">{activeDays}</p>
                      <p>
                        Active day(s)
                        <Tooltip title="Time spent online on IHX platform">
                          <InfoIcon/>
                        </Tooltip>
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col md={8}>
                  <Row className="performance-modal__data-wrapper">
                    <Col md={24}>
                      <p className="value">{daysInDayShift}</p>
                      <p>
                        Day(s) in day shift
                        <Tooltip title="6 am - 6 pm">
                          <InfoIcon/>
                        </Tooltip>
                      </p>
                      </Col>
                  </Row>
                </Col>
                <Col md={8}>
                  <Row className="performance-modal__data-wrapper">
                    <Col md={24}>
                      <p className="value">{daysInNightShift}</p>
                      <p>
                        Day(s) in night shift
                        <Tooltip title="6 pm - 6 am">
                          <InfoIcon/>
                        </Tooltip>
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <Row className="footer">
          <Col md={12} className="ref-text">*Refreshes every 24hr </Col>
          {/* <Col md={12} className="download-button">
            <span onClick={downloadPerformanceCad} className="mouse-pointer">
              <img
                src={`${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/download-icon.svg`}
                className="mr-5"
              />
              Download
            </span>
          </Col> */}
        </Row>
      </Modal>
    </>
    );
  };
export default PerformanceCard;
